// NATIVE 
import { useSelector } from 'react-redux';


// INSTALLED 
import { Grid } from '@mui/material';


// CUSTOM 
import InputField from '../../formFields/InputField';
import AutocompleteField from '../../formFields/autocompleteField';




/**
 * FormaDePagoEditar component renders a form for editing payment details.
 * It uses several selectors to fetch options for various fields from the Redux store.
 * 
 * @param {any} props - The properties passed to the component.
 * @param {object} props.formField - The form fields configuration.
 * @param {object} props.formField.e_payment_frequency - Configuration for the payment frequency field.
 * @param {object} props.formField.e_payment_method - Configuration for the payment method field.
 * @param {object} props.formField.e_associated_bank - Configuration for the associated bank field.
 * @param {object} props.formField.e_type_account_bank - Configuration for the type of account bank field.
 * @param {object} props.formField.e_account_number - Configuration for the account number field.
 * 
 * @returns {JSX.Element} The rendered component.
 */
export const FormaDePagoEditar = (props:any) => {


  const { payment_frequency_select }:any = useSelector( (state:any) => state.paymentfrequency );
  const { payment_method_list_select }:any = useSelector( (state:any) => state.paymentmethod );
  const { associated_bank_select }:any = useSelector( (state:any) => state.associatedbank );
  const { type_account_bank_list_select }:any = useSelector( (state:any) => state.typeaccountbank );
  

    const { formField: {
      e_payment_frequency,
      e_payment_method,
      e_associated_bank,
      e_type_account_bank,
      e_account_number,
    }
  } = props;



  const tdocument = [
    { label: 'Cedula', id: 'hjgjgjhgh'},
    { label: 'Tarjeta de identidad', id: 'sdfdf'}
  ];

 


  return (
    <div>
        <Grid container spacing={2}>
            <Grid size={{ xs: 4 }}>
                <AutocompleteField
                   options={payment_frequency_select}
                   name={e_payment_frequency.name}
                   label={e_payment_frequency.label}
                />
            </Grid>
            <Grid size={{ xs: 4 }}>
                <AutocompleteField
                   options={payment_method_list_select}
                   name={e_payment_method.name}
                   label={e_payment_method.label}
                />
            </Grid>
            <Grid size={{ xs: 4 }}>
                <AutocompleteField
                   options={associated_bank_select}
                   name={e_associated_bank.name}
                   label={e_associated_bank.label}
                />
            </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 4 }}>
                <AutocompleteField
                   options={type_account_bank_list_select}
                   name={e_type_account_bank.name}
                   label={e_type_account_bank.label}
                />
            </Grid>
            <Grid size={{ xs: 4 }}>
                 <InputField
                    name={e_account_number.name}
                    label={e_account_number.label}
                    variant="outlined" 
                    autoComplete="off"
                    fullWidth
                  />
            </Grid>
        </Grid>
       
        
    </div> 
  )
}
